// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n/* datepicker component */\n.mx-datepicker {\n  width: 100%;\n}\n.mx-datepicker > .mx-input-wrapper > .mx-input {\n  height: 40px;\n  border-radius: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
